import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": "",
      "data-cy": "home-container"
    }
  }, [_vm.shouldDisplayAnnouncement ? _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VAlert, {
    attrs: {
      "type": _vm.announcements[0].type,
      "prominent": true,
      "dense": "",
      "dismissible": ""
    },
    on: {
      "input": _vm.closeAlert
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.announcements[0].message)
    }
  }), _vm.announcements[0].link && _vm.announcements[0].link.url ? _c('a', {
    attrs: {
      "href": _vm.announcements[0].link.url,
      "target": "_blank"
    },
    on: {
      "click": _vm.closeAlert
    }
  }, [_c('em', [_vm._v("» " + _vm._s(_vm.announcements[0].link.message || _vm.$i18n_t('accMgmt.announcement.linkMessage')))])]) : _vm._e()])], 1)], 1) : _vm._e(), _vm.showFirstSteps ? _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.home.homeInfoFavText'),
      "subtitle": _vm.$i18n_t('Common.home.gettingStarted')
    }
  }) : _vm._e(), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.showFirstSteps ? _c(VCol, {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCard, {
    staticClass: "mx-auto fav-dtwin-card grey-border elevation-0",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c(VRow, [_vm._l(_vm.firstSteps, function (item, i) {
    return _c(VCol, {
      key: i,
      attrs: {
        "cols": "12",
        "xs": "12",
        "sm": "6",
        "md": "4",
        "lg": _vm.canCreateTickets ? 3 : 4,
        "xl": "3"
      }
    }, [_c(VHover, {
      attrs: {
        "open-delay": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function ({
          hover
        }) {
          return [_c(VCard, {
            staticClass: "mx-auto grey-border clickable",
            attrs: {
              "elevation": hover ? 2 : 0,
              "outlined": ""
            },
            on: {
              "click": function ($event) {
                return _vm.openDialog(i);
              }
            }
          }, [_c(VImg, {
            staticClass: "mt-8 align-end",
            attrs: {
              "src": item.image,
              "height": "100px",
              "contain": ""
            }
          }), _c(VCardTitle, {
            staticClass: "home-tile-title"
          }, [_vm._v(_vm._s(item.title))]), _c(VCardText, {
            staticStyle: {
              "height": "120px"
            }
          }, [_vm._v(_vm._s(item.text))])], 1)];
        }
      }], null, true)
    })], 1);
  }), _vm.canCreateTickets ? _c(VCol, {
    attrs: {
      "cols": "12",
      "xs": "12",
      "sm": "6",
      "md": "4",
      "lg": "3",
      "xl": "3"
    }
  }, [_c(VHover, {
    attrs: {
      "open-delay": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        hover
      }) {
        return [_c(VCard, {
          staticClass: "mx-auto grey-border clickable",
          attrs: {
            "elevation": hover ? 2 : 0,
            "outlined": ""
          },
          on: {
            "click": function ($event) {
              return _vm.pushToRouter(`/fm-add-ticket`);
            }
          }
        }, [_c(VImg, {
          staticClass: "mt-8 align-end",
          attrs: {
            "src": "./img/firstSteps/puzzle-pieces.svg",
            "height": "100px",
            "contain": ""
          }
        }), _c(VCardTitle, {
          staticClass: "home-tile-title"
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Common.home.problemTicketInfoText')) + "\n                  ")]), _c(VCardText, {
          staticStyle: {
            "height": "120px"
          }
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.fmTicketsAddHeadInfoText')))])], 1)];
      }
    }], null, false, 223001319)
  })], 1) : _vm._e()], 2)], 1)], 1)], 1) : _vm._e(), _c(VDialog, {
    attrs: {
      "width": "80%"
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.firstSteps[_vm.dialogNo].title))]), _c(VImg, {
    staticClass: "mt-8 align-end",
    attrs: {
      "src": _vm.firstSteps[_vm.dialogNo].image,
      "height": "500px",
      "contain": ""
    }
  }), _c(VCardText, {
    staticClass: "mt-4"
  }, [_vm._v(_vm._s(_vm.firstSteps[_vm.dialogNo].text))]), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.gotIt'),
      "color": _vm.color,
      "prepend-icon": "fa-check"
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.gotIt')) + "\n          ")])], 1)], 1)], 1), _vm.favorites.length ? [_c(VCol, {
    staticClass: "pb-0 mb-0 ml-0 pl-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.home.favorites'),
      "subtitle": _vm.$i18n_t('Common.home.favoritesHint')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.tileSizeSetting == 1 ? _c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Common.home.favExpand'),
            "color": _vm.color,
            "prepend-icon": "fa-sort-size-down"
          },
          on: {
            "click": _vm.sizeDown
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.home.favExpand')) + "\n            ")]) : _vm._e(), _vm.tileSizeSetting == 0 ? _c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Common.home.favCollapse'),
            "color": _vm.color,
            "prepend-icon": "fa-sort-size-up"
          },
          on: {
            "click": _vm.sizeUp
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.home.favCollapse')) + "\n            ")]) : _vm._e()];
      },
      proxy: true
    }], null, false, 3495316477)
  })], 1), _vm._l(_vm.favorites, function (item, i) {
    return _c(VCol, {
      key: i,
      attrs: {
        "cols": "12",
        "sm": _vm.tileSize.sm,
        "md": _vm.tileSize.md,
        "lg": _vm.tileSize.lg,
        "xl": _vm.tileSize.xl
      }
    }, [_c('core-favoritcard', {
      attrs: {
        "item": item,
        "tileSizeSetting": _vm.tileSizeSetting,
        "componentKey": _vm.componentKey
      },
      on: {
        "invalid": function ($event) {
          return _vm.removeFavorite(item.id);
        }
      }
    })], 1);
  })] : _vm._e(), _vm.showFirstSteps ? [_c(VCol, [_c(VIcon, {
    staticClass: "mr-1 stile-icon",
    attrs: {
      "color": _vm.color,
      "size": "20"
    }
  }, [_vm._v("fal fa-info-circle")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.noFavDef')) + "\n      ")], 1)] : _vm._e(), _vm.$store.state.app.loading ? [_c(VRow, {
    staticClass: "n20-mainrow pt-4"
  }, _vm._l([0, 1, 2], function (twinStateTemplateId) {
    return _c(VCol, {
      key: `state_${twinStateTemplateId}`,
      attrs: {
        "cols": "12",
        "xs": "12",
        "sm": "6",
        "md": "4",
        "lg": "4",
        "xl": "3"
      }
    }, [_c('div', {
      staticClass: "mx-auto text-right",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "outlined": "",
        "elevation": "0"
      }
    }, [_c('div', {
      staticClass: "pa-4"
    }, [_c(VSkeletonLoader, {
      staticStyle: {
        "width": "100%",
        "height": "80%"
      },
      attrs: {
        "type": "image"
      }
    })], 1), _c('div', {
      staticClass: "px-4 pb-4 pt-0"
    }, [_c(VSkeletonLoader, {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "chip"
      }
    })], 1)])]);
  }), 1)] : _vm._e(), _vm.hasAdminRights ? [_c('core-tenant-bridge-errors')] : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };